var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticStyle:{"z-index":"9999"},attrs:{"value":_vm.loader}},[_c('v-progress-circular',{attrs:{"color":"primary","indeterminate":"","size":"64"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }